(function ($) {
  $(document).ready(function () {
    var products = document.getElementsByClassName("cureit-product");
    if (products.length > 0) {
      console.log("Products have been loaded");

      var productModal = document.getElementById("productModal");
      productModal.addEventListener("show.bs.modal", function (event) {
        // Button that triggered the modal
        var button = event.relatedTarget;
        // Extract info from data-bs-* attributes
        var productname = button.getAttribute("data-bs-productname");
        var modalcontent = button.getAttribute("data-bs-modalcontent");
        var productlink = button.getAttribute("data-bs-productlink");
        // Update the modal's content.
        var modalTitle = productModal.querySelector(".modal-header h4");
        var modalBodyInput = productModal.querySelector(".modal-body p");
        var modalProductLink = productModal.querySelector(".product-link");

        modalTitle.textContent = productname;
        modalBodyInput.innerHTML = modalcontent;
        modalProductLink.href = productlink;
      });
    } else {
      console.log("No products have been loaded");
    }

    function checkWindowSize() {
      if (window.matchMedia("(max-width: 768px)").matches) {
        $(".btn-close").attr("data-bs-toggle", "modal");
        $(".btn-close").click(function (e) {
          e.preventDefault();
          // Add your modal triggering code here
        });
      } else {
        $(".btn-close").removeAttr("data-bs-toggle");
        $(".flip-toggle").click(function (e) {
          e.preventDefault();
          var card = $(this).closest(".card");
          var back = card.find(".back");
          var front = card.find(".front");
          back.toggleClass("d-none d-block");
          front.toggleClass("d-none d-block");
        });
      }

      // Get all the cards
      const cards = Array.from(document.querySelectorAll(".card.product"));

      // Group the cards by row
      const rows = cards.reduce((rows, card) => {
        const top = card.getBoundingClientRect().top;
        if (!rows[top]) rows[top] = [];
        rows[top].push(card);
        return rows;
      }, {});

      // For each row...
      Object.values(rows).forEach((row) => {
        // Calculate the maximum height
        const maxHeight = Math.max(
          ...row.map((card) => {
            const front = card.querySelector(".front");
            return front ? front.getBoundingClientRect().height : 0;
          })
        );

        // Set the height of each card's back to the maximum height
        row.forEach((card) => {
          const back = card.querySelector(".back");
          if (back) back.style.height = `${maxHeight}px`;
        });
      });
    }

    checkWindowSize();
    $(window).resize(checkWindowSize);

    // another set of comments
  });

  jQuery(document).ready(function ($) {
    $(".search-toggle").click(function (e) {
      e.preventDefault(); // Prevent the default action
      $("#search-form-container").slideToggle(); // Toggle the search form visibility
    });
  });

  if ($(window).width() > 992) {
    $(".navbar .dropdown").hover(
      function () {
        $(this)
          .find(".dropdown-menu")
          .first()
          .stop(true, true)
          .delay(250)
          .slideDown();
      },
      function () {
        $(this)
          .find(".dropdown-menu")
          .first()
          .stop(true, true)
          .delay(100)
          .slideUp();
      }
    );

    $(".navbar .dropdown > a").click(function () {
      location.href = this.href;
    });
  }

  /* multilevel navigation for Bootstrap 4 */
  $(document).ready(function () {
    $(".dropdown-menu > li > .dropdown-menu")
      .parent()
      .addClass("dropdown-submenu")
      .find(" > .dropdown-item")
      .attr("href", "javascript:;")
      .addClass("dropdown-toggle");
    $(".dropdown-submenu > a").on("click", function (e) {
      var dropdown = $(this).parent().find(" > show");
      $(".dropdown-submenu .dropdown-menu")
        .not(dropdown)
        .removeClass("show remove");
      $(this).next(".dropdown-menu").toggleClass("show toggle");
      // alert("I am a the toggle");
      e.stopPropagation();
    });
    $(".dropdown").on("hidden.bs.dropdown", function () {
      $(".dropdown-menu.show").removeClass("show");
      // alert("I am a the remove");
    });
  });

  $('#target').on('load', function() {
    // Access the iframe's content
    var iframe = document.getElementById('target');
    var iframeDocument = iframe.contentWindow.document || iframe.contentDocument;
  
    // Ensure the iframe uses jQuery and Bootstrap
    var $iframe = $(iframeDocument);
  
    // Listen for the modal to be shown inside the iframe
    $iframe.on('shown.bs.modal', '.modal', function() {
      console.log("modal shown");
        // When the modal is shown, scroll to it
        this.scrollIntoView({ behavior: 'smooth' });
    });
  });
})(jQuery);

document.addEventListener("DOMContentLoaded", function () {
  // make it as accordion for smaller screens
  if (window.innerWidth > 992) {
    document
      .querySelectorAll(".navbar .nav-item")
      .forEach(function (everyitem) {
        everyitem.addEventListener("mouseover", function (e) {
          let el_link = this.querySelector("a[data-bs-toggle]");

          if (el_link != null) {
            let nextEl = el_link.nextElementSibling;
            el_link.classList.add("show");
            nextEl.classList.add("show");
          }
        });
        everyitem.addEventListener("mouseleave", function (e) {
          let el_link = this.querySelector("a[data-bs-toggle]");

          if (el_link != null) {
            let nextEl = el_link.nextElementSibling;
            el_link.classList.remove("show");
            nextEl.classList.remove("show");
          }
        });
      });
  }
  // end if innerWidth
});
// DOMContentLoaded  end
